import { useMutation, useQueryClient } from '@tanstack/react-query';

import { createCommission } from '~/services/AgentHub/AgentService';

import { CreateCommissionParams, CreateCommissionResponse } from '~/types/services/agentHub';

import { commissionQueryKeys } from './useListCommissions';

interface UseCreateCommissionOptions {
  onSuccess?: (data: CreateCommissionResponse) => void;
  onError?: (error: Error) => void;
}

export function useCreateCommission(options: UseCreateCommissionOptions = {}) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (params: CreateCommissionParams) => {
      return await createCommission(params);
    },
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: commissionQueryKeys.all });
      options.onSuccess?.(data);
    },
    onError: (error: Error) => {
      options.onError?.(error);
    },
  });
}
